import Api, { Accommodation, AccommodationRequest } from '@silbo/core';

export const getAccommodationsFromRequestsQuery = (requests: AccommodationRequest[]) =>
  new Api.Query(Accommodation).containedIn('basedOn', requests).select(['startAt', 'basedOn']);
